import { render } from "./DatesRangeCalendar.vue?vue&type=template&id=64545b99&scoped=true"
import script from "./DatesRangeCalendar.vue?vue&type=script&lang=js"
export * from "./DatesRangeCalendar.vue?vue&type=script&lang=js"

import "./DatesRangeCalendar.vue?vue&type=style&index=0&id=64545b99&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64545b99"]])

export default __exports__